export default {"src":"/_next/static/media/gas-station-color.77aa0c35.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};